export const genericConstants = {
  SET_TITLE_GRAL_REQUEST: 'SET_TITLE_GRAL_REQUEST',
  SET_TITLE_GRAL_SUCCESS: 'SET_TITLE_GRAL_SUCCESS',
  SET_TITLE_GRAL_FAILURE: 'SET_TITLE_GRAL_FAILURE',
}
